<template>
    <ui-dialog class="html-editor-tiptap-toolbar-insert-template" :open.sync="isOpen" :closeScrim=false>
      <template #contents>
        <div class="HtmlEditorToolbarInsertTemplate">
            <h1>{{ $t('HtmlEditorToolbarInsertTemplate.InsertTemplate') }}</h1> <br>
            <div class="HtmlEditorToolbarInsertTemplate__templates">
              <div class="HtmlEditorToolbarInsertTemplate__templates_label">Plantilla</div>
              <div>
                <UiPicker
                  :options="templates"
                  optionText="name"
                  optionKey="content"
                  :value="templateSelected"
                  @input="templateSelected = $event"
                  :hideSearch=true
                />
              </div>
            </div>

            <div v-if="templateSelected" class="HtmlEditorToolbarInsertTemplate__content" v-html="templateSelected"></div>
        </div>
      </template>

      <template #footer>
        <button
          type="button"
          class="ui-native --main"
          @click="onAccept"
        >{{ $t('HtmlEditorToolbarInsertTemplate.accept') }}</button>
        <button
          type="button"
          class="ui-native --cancel"
          @click="onCancel"
        >{{ $t('HtmlEditorToolbarInsertTemplate.cancel') }}</button>
      </template>
    </ui-dialog>
  </template>

  <script>
  import { UiDialog, UiPicker } from '@/modules/ui/components';

  import useI18n from '@/modules/i18n/mixins/useI18n.js';
  import useApi from "@/modules/api/mixins/useApi.js";
  import apiTemplates from './api/person/file/library/template.js'

  import app from '../../../../../store/app.js';

  export default {
    components: {
      UiDialog,
      UiPicker
    },

    props: {
      isOpen: {
        type: Boolean,
        required: false,
        default: false,
      },
    },

    mixins: [useI18n, useApi],
    $api: apiTemplates,

    data() {
      return {
        app,
        templateSelected: '',
        templates: []
      }
    },

    methods: {
      onAccept() {
        this.$emit('contentTemplate', this.removeTags(this.templateSelected));
        this.$emit('close');
        this.templateSelected = '';
      },

      onCancel() {
        this.$emit('close');
        this.templateSelected = '';
      },

      allTemplates(personId) {
        this.$api.getTemplates(personId).then(response => { this.templates = response; }).catch(error => console.log(error))
      },

      removeTags(str) {
        if ((str===null) || (str==='')) {
          return false;
        } else {
          str = str.toString();
          return str.replace(/<(p[^>]*|h1[^>]*|h2[^>]*|h3[^>]*|h4[^>]*|h5[^>]*|h6[^>]*)>(<img[^>]+>)<\/\1>/g, '$2');
        }
      }
    },

    mounted() {
      this.allTemplates(app.user.id);
    },

    i18n: {
      en: {
        'HtmlEditorToolbarInsertTemplate.cancel': 'Cancel',
        'HtmlEditorToolbarInsertTemplate.accept': 'Accept',
        'HtmlEditorToolbarInsertTemplate.InsertTemplate': 'Insert template',
      },

      es: {
        'HtmlEditorToolbarInsertTemplate.cancel': 'Cancelar',
        'HtmlEditorToolbarInsertTemplate.accept': 'Aceptar',
        'HtmlEditorToolbarInsertTemplate.InsertTemplate': 'Insertar plantilla',
      },

      de: {
        'HtmlEditorToolbarInsertTemplate.cancel': 'Abbrechen',
        'HtmlEditorToolbarInsertTemplate.accept': 'Akzeptieren',
        'HtmlEditorToolbarInsertTemplate.InsertTemplate': 'Vorlage einfügen',
      },
    },
  }
  </script>

  <style lang="scss">
  .html-editor-tiptap-toolbar-insert-template .ui-dialog-container {
    top: 30% !important;
    bottom: 10% !important;
    max-height: 50% !important;
    max-width: 600px !important;
  }

  .HtmlEditorToolbarInsertTemplate {
    &__templates {
      display: flex;
      align-items: center;
      &_label {
        width: 100px;
      }
    }
    &__content {
      padding: 20px;
      margin-top: 20px;
      border: 1px solid rgb(116, 116, 116);
    }
  }
  </style>